import { Link } from "react-router-dom";
import { avatar } from "utils/assets_exports/images";
import UserPopoverContainer from "./UserPopoverContainer";
import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";

export type ChatListItemProps = CustomComponentProps & {
    isOnline?: boolean;
};

const ChatListItem = ({
    isOnline = true,
    className,
    style
}: ChatListItemProps) => {
    return (
        <div className={`chat-list-item d-flex ${className}`} style={style}>
            <Link
                to="/chat/demo"
                className={`w-full d-flex flex-j-between flex-a-start gap-5 ${className}`}
                style={style}
            >
                <figure className="media-left">
                    <UserPopoverContainer className="myChatPopoverContainer">
                        <div className="p-relative">
                            <img
                                src={avatar}
                                className="chat-list-img box-shadow"
                                alt="user image"
                            />
                            <div
                                className={`chat-status-dot ${isOnline ? "online" : "offline"}`}
                            ></div>
                        </div>
                    </UserPopoverContainer>
                </figure>
                <div className="media-content d-flex flex-col flex-j-center flex-a-start">
                    <Link to="/profile/demo" className="chat-list-item-name">
                        Nelly Schwartz
                    </Link>
                    <span className="chat-list-item-msg">
                        I think we should meet near the Starbucks so we can
                        get...
                    </span>
                </div>
                <div className="d-flex flex-col flex-a-end gap-5">
                    <span className="chat-list-item-time">Yesterday</span>
                    <div className="my-counter">2</div>
                </div>
            </Link>
            <div className="d-flex flex-a-start pr-10 pl-10">
                <div className="dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger">
                    <div>
                        {/* <div className="button is-rounded"> */}
                        <SVG
                            svg="more-vertical"
                            size={20}
                            className="light-grey-svg"
                        />
                        {/* </div> */}
                    </div>
                    <div className="dropdown-menu" role="menu">
                        <div className="dropdown-content">
                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="bell-slash"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Mute</h3>
                                    </div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="bell"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Unmute</h3>
                                    </div>
                                </div>
                            </a>

                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="user-x"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Block</h3>
                                    </div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="user-check"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Unblock</h3>
                                    </div>
                                </div>
                            </a>

                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="follow"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Follow</h3>
                                    </div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="media d-flex flex-j-start flex-a-center gap-10">
                                    <SVG
                                        svg="user-minus"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                    <div className="media-content">
                                        <h3>Unfollow</h3>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatListItem;
